<template>
  <div
    class="py-4 px-2 overflow-y-auto bg-white border-r border-[#f0f1f3] w-[320px] shrink-0 h-full"
  >
    <ul class="space-y-2">
      <NavigationMenuItem
        v-for="item in menuItems"
        :key="item.path || item.label"
        :item="item"
        :depth="0"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import NavigationMenuItem from "./NavigationMenuItem.vue";
import { menuItems } from "./navigationMenu";
</script>
